'use client';

import { useState } from 'react';
import { AppDownloadModal } from '../../../../components/AppDownloadModal/AppDownloadModal';
import { FAQ } from '../../../../components/FAQ/FAQ';
import { FishingReport } from '../../../../components/FishingReportsGrid/components/FishingReportCard';
import { InSeasonSpecies } from '@domain/regulations/getInSeasonSpecies';
import { useAnalytics } from '@domain/analytics/AnalyticsContext';
import { trackEvent } from '@domain/analytics/trackEvent';
import { Document } from '@contentful/rich-text-types';
import {
  FishingWaterCountryFields,
  FishingWaterCountyFields,
  FishingWaterRegionFields,
  FishingWaterTopSpeciesSummaryFields,
  IntersectingCountyNodeFields,
  WaterTypes,
} from '../../../../generated/graphql';
import { getFAQData } from './helpers/getFAQData';

interface IProps {
  county: FishingWaterCountyFields | null;
  country: FishingWaterCountryFields | null;
  descriptionOfWaterType: WaterTypes;
  fishingWaterName: string;
  fishingWaterId: string;
  id?: string;
  inSeasonSpecies: InSeasonSpecies[];
  intersectingCounties: IntersectingCountyNodeFields[];
  latitude: number;
  longitude: number;
  region: FishingWaterRegionFields | null;
  recentCatchPostList: FishingReport[];
  topSpeciesSummary?: FishingWaterTopSpeciesSummaryFields;
  fishingLicenseInfoRichText?: Document;
  licenseUrl?: string;
}

export const FAQSection = ({
  county,
  country,
  descriptionOfWaterType,
  fishingWaterName,
  fishingWaterId,
  id,
  inSeasonSpecies,
  intersectingCounties,
  latitude,
  longitude,
  region,
  recentCatchPostList,
  topSpeciesSummary,
  fishingLicenseInfoRichText,
  licenseUrl,
}: IProps) => {
  const [isAppDownloadModalOpen, setIsAppDownloadModalOpen] = useState(false);
  const { currentPage } = useAnalytics();

  const handleCTAClick = (): void => {
    trackEvent({
      name: 'mykiss_cta_button_clicked',
      properties: {
        source: 'FAQSection',
        source_id: fishingWaterId,
        type: 'downloadModal',
        page: currentPage,
      },
    });
    setIsAppDownloadModalOpen(true);
  };

  const faqData = getFAQData({
    county,
    country,
    descriptionOfWaterType,
    fishingWaterName,
    handleCTAClick,
    inSeasonSpecies,
    fishingLicenseInfoRichText: licenseUrl ? fishingLicenseInfoRichText : undefined,
    licenseUrl,
    intersectingCounties: intersectingCounties,
    latitude,
    longitude,
    region,
    recentCatchPostList,
    topSpeciesSummary,
  });

  return (
    <FAQ
      className="mb-md scroll-mt-(--navigation-scrolltop-offset-mobile) sm:scroll-mt-(--navigation-scrolltop-offset)"
      faqData={faqData}
      headingVariant="sm"
      id={id}
      showFAQMetaData
      title={`FAQ about ${fishingWaterName} fishing`}
    >
      <AppDownloadModal
        appDownloadSourceId={fishingWaterId}
        appDownloadSource="FAQSection"
        isModalOpen={isAppDownloadModalOpen}
        onCloseModal={() => setIsAppDownloadModalOpen(false)}
      />
    </FAQ>
  );
};
